import { PIXI } from '@colonist/pixi';
import { UIGameCardCountBadgeView } from '../ui_game/ui_game_card/UIGameCardCountBadgeView.ts';
import { CardDataController } from '@colonist/game-card-types';
import { SpriteView } from './SpriteView.ts';
import { UIGameSpriteHandler } from '../UIGameSpriteHandler.ts';
import { ViewAnimationControllerAdapter } from './animation/ViewAnimationControllerAdapter.ts';
import { CardEnum, CardTypeEnum } from '@colonist/game-states';
import { CARD_IMAGES, CARD_TIP_BODY, CARD_TIP_TITLE, getIfCardHasBadgeFromType, GameColor } from '@colonist/ui-game';
export class CardView extends PIXI.Container {
    doesCardHaveBadge() {
        if (this.forceCardBadge) return true;
        return getIfCardHasBadgeFromType(this.cardData.cardTypeEnum, this.currentCardCount);
    }
    updateBadge(cardCount) {
        if (this.cardBadgeView == undefined) return;
        this.currentCardCount = cardCount;
        if (this.doesCardHaveBadge()) {
            this.showBadge();
        } else {
            this.hideBadge();
        }
        this.cardBadgeView.updateText(cardCount);
    }
    updateTexture(texture) {
        if (texture == this.view.texture) return;
        this.view.texture = texture;
    }
    hideBadge() {
        this.cardBadgeView.hideBadge();
    }
    showBadge() {
        this.cardBadgeView.showBadge();
    }
    showBadgeForDefaultCards() {
        this.showBadge();
        if (this.doesCardHaveBadge()) return;
        this.hideBadge();
    }
    setTip() {
        this.view.setTip(CARD_TIP_TITLE[this.cardData.cardEnum], [
            CARD_TIP_BODY[this.cardData.cardEnum]
        ]);
    }
    canCardExpand() {
        if (this.cardData.cardTypeEnum === CardTypeEnum.ProgressPolitics) return true;
        if (this.cardData.cardTypeEnum === CardTypeEnum.ProgressScience) return true;
        if (this.cardData.cardTypeEnum === CardTypeEnum.ProgressTrade) return true;
        return false;
    }
    bringCardToFrontOfParent() {
        if (this.parent == undefined) return;
        const parent = this.parent;
        parent.removeChild(this);
        parent.addChild(this);
    }
    fadeOutCard() {
        this.view.tint = GameColor.getColorHexValue(GameColor.Color.CardViewFadedTint);
        this.cardBadgeView.fadeOutBadge();
    }
    fadeInCard() {
        this.view.tint = GameColor.getColorHexValue(GameColor.Color.White);
        this.cardBadgeView.fadeInBadge();
    }
    static getTextureForCard(cardEnum) {
        return UIGameSpriteHandler.getTextureFromSpritesheet(CARD_IMAGES[cardEnum]);
    }
    setAnimation(animation) {
        if (this.currentAnimation != undefined) this.currentAnimation.stop();
        this.currentAnimation = animation;
        this.currentAnimation.start();
    }
    stopAnimation() {
        if (this.currentAnimation == undefined) return;
        this.currentAnimation.stop();
    }
    constructor(currentCardCount, x, y, w, h, cardEnum, container, setTip = false, forceCardBadge = false){
        super();
        this.x = x;
        this.y = y;
        this.width = w;
        this.height = h;
        container.addChild(this);
        this.animationController = new ViewAnimationControllerAdapter(this);
        this.currentCardCount = currentCardCount;
        this.forceCardBadge = forceCardBadge;
        const cardData = CardDataController.getCardDataForCard(cardEnum);
        const texture = CardView.getTextureForCard(cardEnum);
        this.view = new SpriteView(0, 0, w, h, this, texture);
        if (cardData == undefined) return;
        this.cardData = cardData;
        // Mar 1, 2021. Jeff. This is to make sure cards stack nicely in small screens: https://prntscr.com/10aulvn
        const totalNumberOfCards = Object.keys(CardEnum).length / 2;
        const layerCardsByReverseSortingOrder = -this.cardData.cardEnum + totalNumberOfCards;
        this.zIndex = layerCardsByReverseSortingOrder;
        this.cardBadgeView = new UIGameCardCountBadgeView(currentCardCount, this);
        this.hideBadge();
        if (this.doesCardHaveBadge() || forceCardBadge) this.showBadge();
        if (setTip) this.setTip();
    }
}
